'use client';

import React, { useState, useEffect } from 'react';
import { getSectionByKey } from '../../services/cmsService';
import { getImageUrl } from '../../config/api';
import './TestimonialSection.css';

const defaultTestimonials = [
  {
    id: 1,
    text: "The quality and craftsmanship are exceptional. Every piece tells a story and I feel confident wearing RANGAARA designs.",
    name: "Priya Sharma",
    location: "Mumbai",
    avatar: "PS"
  },
  {
    id: 2,
    text: "Absolutely love the handcraft designs! The attention to detail is amazing and the fit is perfect. Highly recommend!",
    name: "Ananya Patel",
    location: "Delhi",
    avatar: "AP"
  },
  {
    id: 3,
    text: "RANGAARA has become my go-to brand for traditional elegance. The designs beautifully blend heritage craftsmanship with modern style.",
    name: "Riya Mehta",
    location: "Bangalore",
    avatar: "RM"
  }
];

const TestimonialSection = ({ initialData }) => {
  const [testimonials, setTestimonials] = useState(defaultTestimonials);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const section = initialData || await getSectionByKey('testimonials_section');
        const list = section?.content?.testimonials;
        if (Array.isArray(list) && list.length > 0) {
          const mapped = list
            .filter(t => t.isActive !== false)
            .map((t, idx) => ({
              id: t.id || idx + 1,
              text: t.testimonial || t.text || '',
              name: t.customerName || t.name || 'Valued Customer',
              location: t.designation || t.location || 'India',
              avatarImg: t.image ? getImageUrl(t.image) : null,
              avatar: (t.customerName || t.name || 'VC').split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase(),
              rating: t.rating || 5
            }));
          if (mapped.length > 0) setTestimonials(mapped);
        }
      } catch (err) {
        console.error('Failed to fetch testimonials from Firestore:', err);
      }
    };
    fetchTestimonials();
  }, []);

  // Duplicate testimonials for seamless loop
  const allTestimonials = [...testimonials, ...testimonials];

  return (
    <section className="testimonial-section">
      <div className="testimonial-header">
        <h2 className="common-heading center testimonial-heading">What Our Customers Say</h2>
        <p className="common-para center testimonial-subtitle">Real stories from people who love our designs.</p>
      </div>
      
      <div className="testimonial-wrapper">
        <div className="testimonial-container">
          {allTestimonials.map((testimonial, index) => (
            <div key={`${testimonial.id}-${index}`} className={`testimonial-card testimonial-card-${testimonial.id}`}>
              <div className="quote-icon">
                <i className="fa-solid fa-quote-left"></i>
              </div>
              <div className="testimonial-stars">
                {[...Array(testimonial.rating || 5)].map((_, i) => (
                  <i key={i} className="fa-solid fa-star"></i>
                ))}
              </div>
              <p className="testimonial-text">{testimonial.text}</p>
              <div className="testimonial-author">
                {testimonial.avatarImg ? (
                  <img src={testimonial.avatarImg} alt={testimonial.name} className="author-avatar-img" style={{ width: '45px', height: '45px', borderRadius: '50%', objectFit: 'cover' }} />
                ) : (
                  <div className="author-avatar">{testimonial.avatar}</div>
                )}
                <div className="author-info">
                  <h3 className="testimonial-name">{testimonial.name}</h3>
                  <p className="testimonial-location">
                    <i className="fa-solid fa-location-dot"></i> {testimonial.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;